import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import './Chat.css';
import { IoSend } from 'react-icons/io5';
import { FaRobot } from 'react-icons/fa';
import OTPAuth from './OTPAuth';


const sendMessageAPI = async (message) => {
  const res = await axios.post('https://stackoverflow-backendagain-9zxt.onrender.com/ask', { message });
  return res.data;
};

const Chat = () => {
  const [message, setMessage] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [conversations, setConversations] = useState([
    { role: 'assistant', content: 'Hello! How can I help you today?' },
  ]);
  const [isOTPVerified, setIsOTPVerified] = useState(false);

  const mutation = useMutation({
    mutationFn: sendMessageAPI,
    mutationKey: ['chatbot'],
    onSuccess: (data) => {
      setIsTyping(false);
      setConversations((prevConversation) => [
        ...prevConversation,
        { role: 'assistant', content: data.message },
      ]);
    },
  });

  const handleSubmitMessage = () => {
    const currentMessage = message.trim();
    if (!currentMessage) {
      alert('Please enter a valid message!');
      return;
    }
    setConversations((prevConversation) => [
      ...prevConversation,
      { role: 'user', content: currentMessage },
    ]);
    setIsTyping(true);
    mutation.mutate(currentMessage);
    setMessage('');
  };

  const handleOTPVerified = () => {
    setIsOTPVerified(true);
  };

  return (
    <>
      <div className="header">
        <h1 className="title">AI Chatbot</h1>
        <p className="description">
          Enter your message in the input below to chat with the AI
        </p>
        {isOTPVerified ? (
          <div className="chat-container">
            <div className="conversation">
              {conversations.map((entry, index) => (
                <div className={`message ${entry.role}`} key={index}>
                  <strong>
                    {entry.role === 'user' ? 'You' : <FaRobot />}
                  </strong>
                  {entry.content}
                </div>
              ))}
              {isTyping && (
                <div className="message assistant">
                  <FaRobot />
                  <strong>AI is Typing...</strong>
                </div>
              )}
            </div>
            <div className="input-area">
              <input
                type="text"
                placeholder="Enter message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSubmitMessage}
              />
              <button onClick={handleSubmitMessage}>
                {mutation?.isPending ? 'Loading' : <IoSend />}
              </button>
            </div>
          </div>
        ) : (
          <OTPAuth onOTPVerified={handleOTPVerified} />
        )}
      </div>
    </>
  );
};

export default Chat;
